module.exports = {
  methods: {
    toDetails(item, code) {
      const { id } = item
      let arr = [
        {
          code: 'wkt',
          name: 'informationServiceWktDetail',
          query: { selectedId: '1' }
        },
        {
          code: 'syxly',
          name: 'informationServiceSzxlyDetail',
          query: { selectedId: '2' }
        },
        {
          code: 'cxsl',
          name: 'informationServiceCxslDetail',
          query: { selectedId: '3' }
        },
        {
          code: 'kcjx',
          name: 'informationServicekcjxDetail',
          query: { selectedId: '4' }
        },
        {
          code: 'zsjs',
          name: 'informationServiceZsjsDetail',
          query: { selectedId: '5' }
        },
        {
          code: 'fxbg',
          name: 'resourceNavigationFxbgDetail',
          query: { selectedId: '1' }
        },
        {
          code: 'fwal',
          name: 'resourceNavigationFwalDetail',
          query: { selectedId: '2' }
        },
        {
          code: 'ywyj',
          name: 'resourceNavigationFwyjDetail',
          query: { selectedId: '3' }
        },
        {
          code: 'xwdt',
          name: 'informationCenterXwtzDetail',
          query: { selectedId: '2' }
        },
        {
          code: 'tzgg',
          name: 'informationCenterTzggDetail',
          query: { selectedId: '1' }
        },
        {
          code: 'jszy',
          name: 'informationServiceJszyDetail',
          query: { selectedId: '4' }
        },
        {
          code: 'zxgz',
          name: 'informationCenterZxgzDetail',
          query: { selectedId: '2' }
        }
      ]

      arr.forEach(res => {
        if (res.code === code) {
          res.query.id = id
          this.$router.push({ query: res.query, name: res.name })
        }
      })
    }
  }
}
